import {CompetitorPageMetaDataModel} from "../../../models/competitor-page.meta-data.model";
import {computed} from "mobx";

export class CompetitorHighlightsPageRouteMetaDataModel extends CompetitorPageMetaDataModel {
  @computed get pageTitle() {
    return this.staticTitle
  }

  @computed get description(): String {
    return this.staticDescription;
  }

  get staticTitle() {
    const staticTitle: String = this.websiteTerms.COMPETITOR_HIGHLIGHTS_TITLE_TEMPLATE.format({
      "COMPETITOR_NAME": this.competitorName,
    });

    return staticTitle;
  }

  get staticDescription() {
    const staticDescription: String = this.websiteTerms.COMPETITOR_HIGHLIGHTS_DESCRIPTION_TEMPLATE.format({
      "COMPETITOR_NAME": this.competitorName,
      "SPORT_TYPE": this.competitorSportName,
    });

    return staticDescription;
  }
}